import 'rc-tree/assets/index.css';
import './MyTreeViewTec.scss';
import React, { useEffect, useState } from 'react';
import Tree from 'rc-tree';
import fnc from '../../mymod/commFunction';

const transformDataToTree = (data) => {
    const treeData = [];
    let currentGroup = null;

    data.forEach(row => {
        if (!currentGroup || currentGroup.id !== `group${row.clGroupCode}`) {
            currentGroup = {
                id: `group${row.clGroupCode}`,
                title: row.groupName,
                key: `group${row.clGroupCode}`,
                children: []
            };
            treeData.push(currentGroup);
        }

        currentGroup.children.push({
            id: row.clClassCode,
            title: row.clClassName,
            key: row.clClassCode
        });
    });

    return treeData;
};

const MyTreeViewTec = ({ setSelectedNodeItem }) => {
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [treeData, setTreeData] = useState([]);
    const userName = fnc.getCookie('userName');

    useEffect(() => {
        const acaCode = fnc.getCookie('acaCode');
        const stCode = fnc.getCookie('stCode');

        fnc.sendAxios('/select/lmsTec/treeview', { acaCode, gangsaCode: stCode }, (res) => {
            if (res && Array.isArray(res)) {
                setTreeData(transformDataToTree(res));
            } else {
                console.log(res, 'kuesbLmsTecRoutes/select/lms/treeview');
            }
        });
    }, []);

    const onExpand = (keys) => {
        setExpandedKeys(keys);
    };

    const onSelect = (keys, selectedItem) => {
        if (selectedItem.node.children) {
            setExpandedKeys(prevKeys => {
                if (prevKeys.includes(selectedItem.node.key)) {
                    return prevKeys.filter(key => key !== selectedItem.node.key);
                }
                return [...prevKeys, selectedItem.node.key];
            });
        }

        setSelectedKeys(keys);
        setSelectedNodeItem(selectedItem);
    };

    return (
        <div className="MyTreeViewTec">
            <div className="box-tv">
                <div className="box-title">
                    {userName} 선생님
                </div>

                <Tree
                    expandedKeys={expandedKeys}
                    selectedKeys={selectedKeys}
                    onExpand={onExpand}
                    onSelect={onSelect}
                    treeData={treeData}
                />
            </div>
        </div>
    );
};

export default MyTreeViewTec;
